import { FC, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { RoutesMap } from "../../types";
import { CustomForm } from "../../components/common/CustomForm/CustomForm";
import { ApiStatus } from "../../types/api/status";
import { CustomBackdrop } from "../../components/common/CustomBackdrop/CustomBackdrop";
import { CustomFormHeader } from "../../components/common/CustomForm/CustomFormHeader";
import { CustomFormBody } from "../../components/common/CustomForm/CustomFormBody";
import { Formik } from "formik";
import { Divider, FormLabel, Grid, TextField } from "@mui/material";
import { CustomFormFooter } from "../../components/common/CustomForm/CustomFormFooter";
import { useTypeAttention } from "../../hooks/useTypeAttention";

type FormData = {
    name: string
}

const TypeAttentionForm: FC = () => {
    const navigate = useNavigate()
    const { status, selectedTypeAttention, createTypeAttentionStore, editTypeAttentionStore } = useTypeAttention()

    const [isEdit, setIsEdit] = useState<boolean>(false)
    const [data, setData] = useState<FormData>({
        name: ''
    });

    useEffect(() => {
        if (Object.entries(selectedTypeAttention).length > 0) {
            setIsEdit(true)
            setData({
                name: selectedTypeAttention.name
            })
        }
    }, []);

    const validateForm = (values) => {
        let errors: any = {};
        if (!values.name) errors.name = "El nombre es requerido";
        return errors;
    }

    const onSubmit = async (values) => {
        const payload = {
            name: values.name
        }
        const method = !isEdit ? createTypeAttentionStore(payload) : editTypeAttentionStore(selectedTypeAttention.id, payload)
        const response = await method
        if (response.status === true) {
            navigate({ pathname: RoutesMap.TYPE_ATTENTION })
        }
    }

    const onCancel = async () => {
        navigate({ pathname: RoutesMap.TYPE_ATTENTION })
    }

    return (
        <CustomForm>
            {status === ApiStatus.FETCHING && <CustomBackdrop open={true} />}
            <CustomFormHeader
                title={!isEdit ? 'Nuevo tipo de atención' : 'Editar tipo de atención'}
                text={!isEdit ? 'Ingrese los datos del nuevo tipo de atención' : 'Ingrese los datos del tipo de atención'}
                goBack={RoutesMap.TYPE_ATTENTION}
            />
            <CustomFormBody>
                <Formik initialValues={data} enableReinitialize validate={(values) => validateForm(values)} onSubmit={onSubmit}>
                    {({ values, errors, touched, handleSubmit, handleChange, setFieldValue }) => {
                        return (
                            <form onSubmit={handleSubmit}>
                                <Grid container sx={{ padding: '20px' }}>
                                    <Grid item container xs={12} spacing={2}>
                                        <Grid item xs={12}>
                                            <FormLabel>Nombre:</FormLabel>
                                            <TextField
                                                id="name"
                                                type="text"
                                                name="name"
                                                fullWidth
                                                size="small"
                                                value={values.name}
                                                onChange={handleChange}
                                                error={errors.name && touched.name ? true : false}
                                                helperText={errors.name && touched.name ? errors.name : ''}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Divider />
                                <CustomFormFooter
                                    buttonType="submit"
                                    confirmText={!isEdit ? 'Guardar' : 'Actualizar'}
                                    cancelText={"Cancelar"}
                                    onConfirm={handleSubmit}
                                    onCancel={onCancel}
                                />
                            </form>
                        )
                    }}
                </Formik>
            </CustomFormBody>
        </CustomForm>
    )
}

export default TypeAttentionForm